export default __webpack_public_path__ + "static/media/openhouse-icon.d8b3ec5f.png";